// EventCard.js
import React, { Component } from 'react';
import { Card, Button } from 'react-bootstrap';

export class EventCard extends Component {
  render() {
    const {actionLabel, title, date, time, location, actionHref, bg,text="light" } = this.props;
    return (
      <Card
        bg={bg}
        text={text}
        className="p-4 mb-5 border-0"
        style={{ maxWidth: '400px' }}
      >
        <Card.Subtitle className="text-warning mb-2">
          {title}
        </Card.Subtitle>
         {date && date.length  && 
        (<Card.Title as="h3">{date} </Card.Title>)
         }
         {time && time.length  && 
          (<Card.Text>{time}</Card.Text>)
         }
         {location && location.length  && 
        <Card.Text>
          <i className="bi bi-geo-alt-fill me-1" /> {/* Requires Bootstrap Icons */}
          {location}{' '}
        </Card.Text>
        }
        {actionHref && (
          <Button
            variant="warning"
            href={actionHref}
            target="_blank"
            rel="noopener noreferrer"
          >
            {actionLabel}
          </Button>
        )}        
      </Card>
    );
  }
}
